module.exports = __webpack_public_path__ + "static/img/so3_7.9640ec6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_7.jpg
// module id = 72+1
// module chunks = 11